// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 2P2seF7EsNRtVPgrUDdpUM
// Component: B9ZCf2MIsEY
import * as React from "react";
import { Link } from "gatsby";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import { useScreenVariants as useScreenVariantsvfX27Kk2D5M } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: VfX27Kk2d5M/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import * as projectcss from "./plasmic_isaacpalka_com.module.css"; // plasmic-import: 2P2seF7EsNRtVPgrUDdpUM/projectcss
import * as sty from "./PlasmicTalkPreview.module.css"; // plasmic-import: B9ZCf2MIsEY/css

createPlasmicElementProxy;

export const PlasmicTalkPreview__VariantProps = new Array();

export const PlasmicTalkPreview__ArgProps = new Array(
  "title",
  "date",
  "summary",
  "destination",
  "thumbnail"
);

const $$ = {};

function PlasmicTalkPreview__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsvfX27Kk2D5M()
  });
  return (
    <p.Stack
      as={p.PlasmicLink}
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.a,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root
      )}
      component={Link}
      href={args.destination}
      platform={"gatsby"}
      target={"_blank"}
    >
      <p.Stack
        as={"div"}
        hasGap={true}
        className={classNames(projectcss.all, sty.freeBox___4XrJ2)}
      >
        <div
          data-plasmic-name={"title"}
          data-plasmic-override={overrides.title}
          className={classNames(projectcss.all, sty.title)}
        >
          {p.renderPlasmicSlot({
            defaultContents: "Talk Title",
            value: args.title,
            className: classNames(sty.slotTargetTitle)
          })}
        </div>
        <p.Stack
          as={"div"}
          data-plasmic-name={"date"}
          data-plasmic-override={overrides.date}
          hasGap={true}
          className={classNames(projectcss.all, sty.date)}
        >
          {p.renderPlasmicSlot({
            defaultContents: "Jan 1, 2021",
            value: args.date,
            className: classNames(sty.slotTargetDate)
          })}
        </p.Stack>
        <p.Stack
          as={"div"}
          hasGap={true}
          className={classNames(projectcss.all, sty.freeBox__tDRzi)}
        >
          <div className={classNames(projectcss.all, sty.freeBox__re1TW)}>
            {p.renderPlasmicSlot({
              defaultContents: (
                <p.PlasmicImg
                  alt={""}
                  className={classNames(sty.img__tWyDj)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"100%"}
                  loading={"lazy"}
                />
              ),

              value: args.thumbnail
            })}
          </div>
          <div
            data-plasmic-name={"blurb"}
            data-plasmic-override={overrides.blurb}
            className={classNames(projectcss.all, sty.blurb)}
          >
            {p.renderPlasmicSlot({
              defaultContents:
                "Test title Sub title Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum id suscipit ante. Vestibulum pharetra libero tincidunt nisl semper pretium. Maecenas dictum tellus sed vestibulum euismod.",
              value: args.summary,
              className: classNames(sty.slotTargetSummary)
            })}
          </div>
        </p.Stack>
      </p.Stack>
    </p.Stack>
  );
}

const PlasmicDescendants = {
  root: ["root", "title", "date", "blurb"],
  title: ["title"],
  date: ["date"],
  blurb: ["blurb"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTalkPreview__ArgProps,
          internalVariantPropNames: PlasmicTalkPreview__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTalkPreview__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicTalkPreview";
  } else {
    func.displayName = `PlasmicTalkPreview.${nodeName}`;
  }
  return func;
}

export const PlasmicTalkPreview = Object.assign(
  // Top-level PlasmicTalkPreview renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    title: makeNodeComponent("title"),
    date: makeNodeComponent("date"),
    blurb: makeNodeComponent("blurb"),
    // Metadata about props expected for PlasmicTalkPreview
    internalVariantProps: PlasmicTalkPreview__VariantProps,
    internalArgProps: PlasmicTalkPreview__ArgProps
  }
);

export default PlasmicTalkPreview;
/* prettier-ignore-end */
